<template>
    
    <div>

        <v-container style="max-width:500px">
            <div class="mb-3" v-for="(song,index) in sortedSongs.slice(0,songsShown)" :key="index">
                <v-layout class="synThickFont" row wrap align-center>
                
                    <!-- INDIVIDUAL SONG CONTENT -->
                    <v-flex xs1>
                            <v-img :src="'/song_icons/'+song.icon" width="50px"></v-img>
                        </v-flex>
                    <v-flex fill-height xs6>
                        <div class="pl-3 linkHover"><router-link class="rl-no-dec syn_blue_button--text synThickFont" :to="{ name: 'Song', params: { songId: song.song_id }}">{{song.title}}</router-link></div>
                        <!-- <v-btn text color="blue"  :to="{ name: 'Song', params: { songId: song.song_id }}">{{song.title}}</v-btn>     -->
                        
                    </v-flex>

                    <v-flex xs5 class="text-right">             
                        <v-btn text color='syn_green' class="linkHover" @click.native.stop :to="{ name: 'SubmitSong_ChooseArtist', params: { songId: song.song_id}}">
                            <span>Submit</span>
                        </v-btn>
                    </v-flex>
                    
                    <!-- <v-flex xs2 class='text-center'>
                        
                        <DeleteSong v-if="filterSubmissions(song.song_id).length == 0"
                        :current_song_id="song.song_id"
                        :current_song_audioPath="song.audioPath" 
                        @deleteSuccess="forceRerender"
                        /> 
                        <v-tooltip v-else bottom>
                        <template v-slot:activator="{ on, attrs }">

                            <div v-bind="attrs" v-on="on">
                            <v-btn  @click.native.stop disabled text >
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                            </div>
                            
                        </template>
                        <span class="synThinFont">You cannot delete a song after submitting it for a feedback report.</span>
                        </v-tooltip>

                        
                    </v-flex> -->
                
                </v-layout>
            </div>
        </v-container>
        <div class="text-center">
            <v-btn text color="primary" class="linkHover" v-if="sortedSongs.length > 4 && songsShown < sortedSongs.length" @click="loadMore">load more</v-btn>
        </div>
        
    </div>
</template>
<script>
import moment from 'moment'
export default {
    name: "SongsEPDetailedExtraSmall",
    data() {
        return {
            songsShown: 4,
        }
    },
    props: {
        sortedSongs: Array,
        submissions: Array,
        user: Object
    },
    methods:{
        loadMore(){
          this.songsShown += 4
        },
        forceRerender() {
            this.$router.go()
        },
        filterSubmissions(song_id){
            let filteredSubmissions = this.submissions.filter(function(event){
                return event.song_id == song_id
            })
            return filteredSubmissions
        },
        expiryHours(timestamp){
            var now = moment(Date.now()); //current time
            var end = moment(timestamp+259200000); // due date
            var duration = moment.duration(end.diff(now));
            var hours = duration.asHours();
            var floorHours = Math.floor(hours)
            var output
            if (floorHours > 1) {
                output = floorHours + " hours"
            } else if (floorHours == 1){
                output = floorHours + " hour"
            } else {
                output = "OVERDUE"
            }

            return output
        },
    },

}
</script>
<style>
.rl-no-dec{
    text-decoration: none;
}
</style>